module.exports = function InvalidMonthError(message) {
  this.message = message;
  this.name = 'InvalidMonthError';
};
